/**
 * Defines the supported cultures in the user interfaces and logic.
 * Cultures define how e.g. numbers and dates are presented.
 * Currently only imports / exports support Cultures: Finnish culture is used typically in English and Swedish user interfaces.
 */
export enum Culture {
  /** Finnish culture. Number 12,34 / Date: 1.2.2020 / CSV separator is semi-colon (";"). */
  Fi = "fi",
  /** International (en-US) culture. Number 12.34 / Date: 2020-02-01 / CSV separator is comma (","). */
  En = "en",
}